module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-PJH5TKZB","includeInDevelopment":false,"enableWebVitalsTracking":true,"selfHostedOrigin":"https://avadireito.com","selfHostedPath":"metrics","defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"AvaDireito.com","short_name":"AvaDireito.com","description":"AvaDireito: Estágio Supervisionado I, II, III e IV. Peças processuais fundamentadas e estruturadas no padrão acadêmico do AVA.","start_url":"/","background_color":"#fff","display":"standalone","icon":"static/sites/avadireito/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c041277c2f65da4dacfba6d552bb6c56"},
    },{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
